import { Longhand } from "../longhand.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/container-type}
 * @internal
 */
export default Longhand.fromKeywords({ inherits: false }, "normal", "size", "inline-size");
//# sourceMappingURL=container-type.js.map